var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGeneratewhitefull(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4L13.8095 8.58803C13.9765 9.01154 14.06 9.2233 14.1879 9.40186C14.3013 9.56014 14.4399 9.69872 14.5981 9.81208C14.7767 9.93996 14.9885 10.0235 15.412 10.1905L20 12L15.412 13.8095C14.9885 13.9765 14.7767 14.06 14.5981 14.1879C14.4399 14.3013 14.3013 14.4399 14.1879 14.5981C14.06 14.7767 13.9765 14.9885 13.8095 15.412L12 20L10.1905 15.412C10.0235 14.9885 9.93996 14.7767 9.81208 14.5981C9.69872 14.4399 9.56014 14.3013 9.40186 14.1879C9.2233 14.06 9.01154 13.9765 8.58803 13.8095L4 12L8.58803 10.1905C9.01154 10.0235 9.2233 9.93996 9.40186 9.81208C9.56014 9.69872 9.69872 9.56014 9.81208 9.40186C9.93996 9.2233 10.0235 9.01154 10.1905 8.58803L12 4Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.77778,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneratewhitefull);
export default __webpack_public_path__ + "static/media/generatewhitefull.245d69d4a80fb30fbe886bc1ad9dd8a4.svg";
export { ForwardRef as ReactComponent };